import React from 'react'

import BaseTransportSummary from './BaseTransportSummary'

import { BusItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: BusItem
}

function BusItemSummary(props: Props) {
  return <BaseTransportSummary transportName="Bus" {...props} />
}

export default BusItemSummary
